'use client';

import { FC } from 'react';
import { FinderResultHeroStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { H2 } from 'atoms/Typography';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const FinderResultHero: FC<{
  blok: FinderResultHeroStoryblok;
}> = ({ blok }) => {
  const { desktopHero, mobileHero, title } = blok;
  const { isMobile } = useMediaQuery();

  const isBlokVisible = desktopHero || mobileHero || title;

  const getHeroBackground = () => {
    if (isMobile && mobileHero?.filename) {
      return { backgroundImage: `url(${mobileHero.filename})` };
    }

    if (desktopHero?.filename) {
      return { backgroundImage: `url(${desktopHero.filename})` };
    }
  };

  return !isBlokVisible ? null : (
    <Container>
      <div className={styles.hero} style={getHeroBackground()}>
        {title && <H2 className={styles.title}>{title}</H2>}
      </div>
    </Container>
  );
};
